export const prizeOptions = [
  { label: "Efectivo", value: "CASH" },
  { label: "En especie", value: "IN_SPECIE" },
  { label: "Beca", value: "SCHOLARSHIP" },
  { label: "Otro", value: "OTHER" }
];